import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";

export const SortableList = ({list, children, isActiveDrop, editingListId, disabled = false}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: `list-${list.id}`,
        disabled: disabled || editingListId !== null,
        data: {
            type: "list",
            list,
        },
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`sortableListWrapper ${isActiveDrop ? "sortableListWrapper--over" : ""}`}
        >
            {typeof children === "function"
                ? children(
                    editingListId === null ?
                        {
                            dragHandleProps: {
                                ...attributes,
                                ...listeners,
                            },
                        } : {}
                )
                : children}
        </div>
    );
};
